<template>
  <div class="video-container">
    <div class="video">
      <button
        type="button"
        class="no-style video-poster-button"
        :aria-label="`Play ${title}`"
        v-show="!playing"
        @click="playVideo"
      >
        <img :src="poster" :id="posterID" :alt="alt" :role="alt ? false : 'presentation'" />
      </button>
      <iframe
        :src="sourceUrl"
        frameborder="0"
        allowfullscreen
        id="iframeVid"
        allow="autoplay"
        :title="title"
      ></iframe>
    </div>
  </div>
</template>

<script>
let uid = 0;

export default {
  props: {
    src: {
      type: String,
    },
    posterimg: {
      type: String,
    },
    title: {
      type: String,
      default: 'video',
    },
    alt: {
      type: String,
      default: '',
    },
  },
  data() {
    uid += 1;
    return {
      // Was Math.random() * 100, which collided when a page had several videos.
      posterID: `posterImg_${uid}`,
      sourceUrl: this.$props.src,
      playing: false,
    };
  },
  computed: {
    poster() {
      if (typeof this.$props.posterimg !== 'undefined') {
        return this.$props.posterimg;
      } else {
        return null;
      }
    },
  },
  methods: {
    playVideo() {
      this.playing = true;
      var symbol = this.sourceUrl.indexOf('?') > -1 ? '&' : '?';
      //modify source to autoplay and start video
      this.sourceUrl += symbol + 'autoplay=1';
      // Hand focus to the player so the keyboard user lands on what they just started.
      this.$nextTick(() => {
        var frame = this.$el.querySelector('iframe');
        if (frame) frame.focus();
      });
    },
  },
};
</script>

<style scoped>
.video {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
}

/* The poster is now a <button> so it can be reached and activated by keyboard. Its only
   child is absolutely positioned, so without this the button would collapse to zero size:
   impossible to click and with an invisible focus ring. */
.video .video-poster-button {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 21;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
}
.video img {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 20;
  cursor: pointer;
}

.video iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* image poster clicked, player class added using js */
.video.player img {
  display: none;
}
.video.player:after {
  display: none;
}
</style>
